import { OverlayRef } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NotificationBarRef {
  overlayRef!: OverlayRef | null;

  private openedSubject = new Subject<void>();
  private closedSubject = new Subject<boolean>();
  private disposedSubject = new Subject<void>();

  constructor(overlayRef: OverlayRef) {
    this.overlayRef = overlayRef;
    this.openedSubject.next();
  }

  close(primaryAction = false) {
    this.dispose();
    this.closedSubject.next(primaryAction);
  }

  onOpen() {
    return this.openedSubject.asObservable();
  }

  onClose() {
    return this.closedSubject.asObservable();
  }

  private dispose() {
    this.overlayRef && this.overlayRef.dispose();
    this.overlayRef = null;
    this.disposedSubject.next();
  }
}
